/**
 * @generated SignedSource<<d80f7d0ff9603164220854dca3c97889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlightsRow_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRowActions_package">;
  readonly " $fragmentType": "PackageEditTransportFlightsRow_package";
};
export type PackageEditTransportFlightsRow_package$key = {
  readonly " $data"?: PackageEditTransportFlightsRow_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRow_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlightsRow_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlightsRowActions_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "3eb32a1057733af32db75ade39c95032";

export default node;
